
import { state } from "@/store/modules/encaste/chicks/state";
import mutations from "@/store/modules/encaste/chicks/mutations"
import actions from "@/store/modules/encaste/chicks/actions"
import getters from "@/store/modules/encaste/chicks/getters"

/** @returns { import('vuex').Module } */
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}